import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { orgDashboardListCreditsRoute } from 'modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardListCreditsContainerLoadable } from './OrgDashboardListCreditsContainerLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardListCreditsRoute>,
) {
  await OrgDashboardListCreditsContainerLoadable.load();
}

export default function OrgDashboardListCreditsHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <OrgDashboardListCreditsContainerLoadable />;
}
